import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Snowflake, Zap } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-20 px-6 bg-brand-brown text-brand-beige" data-id="element-149">
      <div className="max-w-5xl mx-auto" data-id="element-150">
        <FadeIn data-id="element-151">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-8 text-white" data-id="element-152">
            El Protocolo de la Alacena
          </h2>
          <p className="text-xl text-center max-w-3xl mx-auto mb-16 opacity-90 leading-relaxed" data-id="element-153">
            Un método de dos pasos diseñado específicamente para regenerar la
            movilidad mientras duerme, utilizando elementos que ya tiene en
            casa.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-154">
          <FadeIn delay={0.2} data-id="element-155">
            <div className="bg-white bg-opacity-10 p-8 rounded-2xl h-full" data-id="element-156">
              <h3 className="text-2xl font-serif font-bold mb-4 text-brand-sage" data-id="element-157">
                1. Anti-inflamatorios Naturales
              </h3>
              <p className="text-lg opacity-90 leading-relaxed" data-id="element-158">
                Ingredientes específicos de su cocina que actúan desde adentro
                hacia afuera, apagando el "incendio" articular sin los efectos
                secundarios de los fármacos agresivos.
              </p>
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-159">
            <div className="bg-white bg-opacity-10 p-8 rounded-2xl h-full" data-id="element-160">
              <h3 className="text-2xl font-serif font-bold mb-4 text-brand-sage" data-id="element-161">
                2. Compresión Térmica Nocturna
              </h3>
              <p className="text-lg opacity-90 leading-relaxed" data-id="element-162">
                Una técnica sencilla para preparar su rodilla antes de dormir,
                asegurando que los tejidos se desinflamen y reparen durante la
                noche.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} data-id="element-163">
          <div className="text-center mb-12" data-id="element-164">
            <h3 className="text-2xl font-serif font-bold mb-12 text-white" data-id="element-165">
              El Sistema R.E.A.
            </h3>
            <div className="flex flex-col md:flex-row justify-center items-center gap-12 md:gap-4 relative" data-id="element-166">
              <div className="hidden md:block absolute top-10 left-1/4 right-1/4 h-1 bg-brand-sage opacity-30 z-0" data-id="element-167"></div>

              {[{
              icon: <ShieldCheck className="w-8 h-8" data-id="element-168" />,
              title: 'Rescate',
              desc: 'Alivio inmediato'
            }, {
              icon: <Snowflake className="w-8 h-8" data-id="element-169" />,
              title: 'Enfriamiento',
              desc: 'Reducción de inflamación'
            }, {
              icon: <Zap className="w-8 h-8" data-id="element-170" />,
              title: 'Activación',
              desc: 'Recuperación de movilidad'
            }].map((step, idx) => <div key={idx} className="relative z-10 flex flex-col items-center bg-brand-brown px-4 w-full md:w-1/3" data-id="element-171">
                  <div className="w-20 h-20 rounded-full bg-brand-sage text-brand-brown flex items-center justify-center mb-6 shadow-lg border-4 border-brand-brown" data-id="element-172">
                    {step.icon}
                  </div>
                  <h4 className="text-xl font-bold mb-2 text-white" data-id="element-173">
                    {step.title}
                  </h4>
                  <p className="text-base opacity-80" data-id="element-174">{step.desc}</p>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}